import { ButtonMui } from '../../../../components/ButtonMui'
import theme from '../../../../styles/theme'
import styled from 'styled-components'

export const Container = styled.div`
  width: 50%;
`
export const SubTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-left: .5rem;
  width: 100%;
`

export const ContainerCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 60vh;
  overflow-Y: auto;
  padding: .5rem;
  width: 100%;
`

export const ContainerButtons = styled.div`
  display: flex;
`

export const CustomButton = styled(ButtonMui)`
  width: 50%;    
  height: 2.5rem !important;
  margin: .4rem !important;
`

export const Selected = styled.span<{hasSelected: boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ hasSelected }) => (hasSelected ? theme.colors.confirm : theme.colors.disabled)};
  width: 178px;
  height: 24px;
  border-radius: 56px;
  color: #FFF;
  padding: 10px;
  margin: .5rem .5rem 0 0;
`
